import URLConfig from '@Config/urls/url.config';
import * as BatchesProcessingModule from '@Modules/batchesProcessing/pages';
import { Route } from "react-router-dom";

const URL = URLConfig.BATCHES_PROCESSING.BATCHES_MANAGEMENT_MENU;

const BatchesProcessingRoutes = [
  // Batches Management Menu Routes
  <Route
    path={URL.BATCHES_PARAMETERS}
    element={<BatchesProcessingModule.BatchesParametersPage />}
  />,
  <Route
    path={URL.BATCHES_DEPENDENCIES}
    element={<BatchesProcessingModule.BatchesDependenciesPage />}
  />,
  <Route
    path={URL.BATCHES_MONITORING}
    element={<BatchesProcessingModule.BatchesMonitoringPage />}
  />,
  <Route
    path={URL.BATCHES_MAINTENANCE}
    element={<BatchesProcessingModule.BatchesMaintenancePage />}
  />,
  <Route
    path={URL.BATCH_ERRORS}
    element={<BatchesProcessingModule.BatchErrorsPage />}
  />,
  <Route
    path={URL.BATCHES_TRACKS}
    element={<BatchesProcessingModule.BatchesTracksPage />}
  />,
  
  // Daily Processing Sub-Menu Routes
  <Route
    path={URL.DAILY_PROCESSING_MENU.UPDATE}
    element={<BatchesProcessingModule.UpdatePage />}
  />,
  <Route
    path={URL.DAILY_PROCESSING_MENU.DEPENDENCIES}
    element={<BatchesProcessingModule.DependenciesPage />}
  />,
  <Route
    path={URL.DAILY_PROCESSING_MENU.SUPERVISION}
    element={<BatchesProcessingModule.SupervisionPage />}
  />,
  <Route
    path={URL.DAILY_PROCESSING_MENU.TRACES}
    element={<BatchesProcessingModule.TracksPage />}
  />,
  <Route
    path={URL.DAILY_PROCESSING_MENU.ERRORS}
    element={<BatchesProcessingModule.ErrorsPage />}
  />,
  
];

export default BatchesProcessingRoutes;
